import { useQuery } from "@tanstack/react-query";
import { axios } from "../../../shared/lib/axios";
import _cookies from "../../../shared/utils/_cookies";

export const getPostLikes = async (params) => {
  const res = await axios.middleware.get("/Social.asmx/ListarReacoes", {
    params,
  });
  return res[0].data;
};

export const usePostLikes = ({ config, postId } = {}) => {
  return useQuery({
    ...config,
    queryKey: ["socialMediaPostLikes", { postId }],
    queryFn: () =>
      getPostLikes({
        postagemid: postId,
        tipoReacao: "LIKE",
      }),
  });
};
